<div
  class="container-fluid"
  [ngClass]="{ 'p-0': mobileMode(), 'h-100': mobileMode() }"
  style="position: relative"
  [style.background-color]="clozeTestStyleModel().siteBackground">
  <div class="d-flex justify-content-center" [ngClass]="{ 'h-100': mobileMode() }">
    <div
      class="card"
      [ngClass]="{ 'container-fluid': mobileMode(), 'p-0': mobileMode() }"
      style="min-height: 570px"
      [style.background-color]="clozeTestStyleModel().exerciseBackground"
      [ngStyle]="{
        border: mobileMode() ? '0' : '1px solid ' + clozeTestStyleModel().frameColor,
        'border-radius': mobileMode() ? '0' : '0.25rem',
        width: mobileMode() ? '' : '720px',
      }">
      <!-- mobile exercise header -->
      @if (mobileMode()) {
        <div class="onset-indicator">
          <img
            [alt]="'GAST-ONSET-NG.INTRODUCTION.LOGO' | translate"
            style="max-width: 100px; float: right"
            [src]="cTestLogo()" />
        </div>
      }
      <!-- mobile exercise indicator end -->
      <div
        class="card-body"
        [ngClass]="{ 'card-mobile': mobileMode() }"
        [style.font-family]="clozeTestStyleModel().font"
        [style.font-size]="clozeTestStyleModel().fontSize">
        @if (clozeTestStyleModel().displayLogo && !mobileMode()) {
          <img [alt]="'GAST-ONSET-NG.INTRODUCTION.LOGO' | translate" class="floating-logo" [src]="cTestLogo()" />
        }
        @if (clozeTestStyleModel().displayLogo && mobileMode()) {
          <div class="row"></div>
        }
        @if (!mobileMode()) {
          <h5
            class="card-title text-center font-weight-bold"
            [innerHTML]="'GAST-ONSET-NG.INTRODUCTION.TITLE' | translate"></h5>
        }
        @if (mobileMode()) {
          <h5
            class="card-title text-center font-weight-bold"
            [innerHTML]="'GAST-ONSET-NG.MOBILE.INTRODUCTION.TITLE' | translate"></h5>
        } @else {
          <h6
            class="card-subtitle mb-2 text-muted text-center"
            [innerHTML]="'GAST-ONSET-NG.INTRODUCTION.SUBTITLE' | translate"></h6>
        }
        @if (mobileMode()) {
          <div>
            <div class="mt-4 instruction-container">
              <img
                [alt]="'GAST-ONSET-NG.INTRODUCTION.TEXT_LOGO' | translate"
                class="instruction-icon"
                src="onset-assets/img/onSET_Text.svg" />
              <span class="instruction-text">{{ "GAST-ONSET-NG.MOBILE.INTRODUCTION.INSTRUCTION_1" | translate }}</span>
            </div>
            <div class="mt-4 instruction-container">
              <img
                [alt]="'GAST-ONSET-NG.INTRODUCTION.TIME_LOGO' | translate"
                class="instruction-icon"
                src="onset-assets/img/onSET_Zeit.svg" />
              <span class="instruction-text">{{ "GAST-ONSET-NG.MOBILE.INTRODUCTION.INSTRUCTION_2" | translate }}</span>
            </div>
            <div class="mt-4 instruction-container">
              <img
                [alt]="'GAST-ONSET-NG.MOBILE.INTRODUCTION.TIME_OUT_LOGO' | translate"
                class="instruction-icon"
                src="onset-assets/img/onSET_Zeit_fertig.svg" />
              <span class="instruction-text">{{ "GAST-ONSET-NG.MOBILE.INTRODUCTION.INSTRUCTION_3" | translate }} </span>
            </div>
            <div class="mt-4 instruction-container">
              <img
                [alt]="'GAST-ONSET-NG.MOBILE.INTRODUCTION.FINISH_LOGO' | translate"
                class="instruction-icon"
                src="onset-assets/img/onSET_Text_beenden.svg" />
              <span class="instruction-text">{{ "GAST-ONSET-NG.MOBILE.INTRODUCTION.INSTRUCTION_4" | translate }}</span>
            </div>
          </div>
        }
        <br />
        @if (!mobileMode()) {
          <div class="card-text mb-4" [innerHTML]="'GAST-ONSET-NG.INTRODUCTION.CONTENT' | translate"></div>
        }
        <div class="text-center">
          @if (!mobileMode()) {
            <button
              class="btn"
              style="font-size: smaller"
              [style.background-color]="cTestButtonColor()"
              (click)="toggleStartTest()">
              {{ "GAST-ONSET-NG.MOBILE.INTRODUCTION.START_TEST" | translate }}
            </button>
          }
          @if (mobileMode()) {
            <p style="text-align: start">
              {{ "GAST-ONSET-NG.MOBILE.INTRODUCTION.START_EXAMPLE_INFO" | translate }}
            </p>
            <button
              class="btn"
              style="font-size: smaller"
              [style.background-color]="cTestButtonColor()"
              (click)="toggleStartTestExample()">
              {{ "GAST-ONSET-NG.MOBILE.INTRODUCTION.START_EXAMPLE" | translate }}
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
